export default "__VITE_ASSET__BxHTkwYD__"